import moment from 'moment-timezone';

// Default timezone constant
export const DEFAULT_TIMEZONE = 'Asia/Singapore';

// Helper function to get the minimum date (90 days ago) in the default timezone
export const getMinDate90DaysAgo = () => {
    return moment().tz(DEFAULT_TIMEZONE).subtract(90, 'days').startOf('day').toDate();
};

// Helper function to get the maximum date (90 days from now) in the default timezone
export const getMaxDate90DaysFromNow = () => {
    return moment().tz(DEFAULT_TIMEZONE).add(90, 'days').endOf('day').toDate();
};

